<template>
	<div>
		<v-card class="mx-auto productCard" max-width="344" :loading="loading">
			<template v-slot:loader="{ isActive }">
				<v-progress-linear
					:active="isActive"
					color="deep-purple"
					height="4"
					indeterminate
				></v-progress-linear>
			</template>
			<v-img
				:src="`${product.img_path}`"
				height="200px"
				cover
				class="fitProductImage"
			></v-img>
			<div style="text-align: left">
				<div class="card-title bold">{{product.product_name}}</div>
				<v-card-subtitle style="padding-top: 0px; text-transform: uppercase;">{{product.category_name}}</v-card-subtitle>
				<v-card-text style="padding-bottom: 0px;">{{product.client_address}}, {{product.client_postal_code}} {{product.client_city}}</v-card-text>
			</div>
			<v-divider class="mx-4 mb-1"></v-divider>
			<div class="px-4">
				<v-chip-group>
					<v-chip>{{ $t('wholesale_price') }}: <strong style="margin-left: 3px;"> {{product.wholesale_price}} EUR</strong></v-chip>
				</v-chip-group>
				<div class="suggSellingPrice">
					<div style="text-align: left; text-transform: lowercase;">({{ $t('sugg_selling_price') }}: {{product.sugg_selling_price}} EUR)</div>
				</div>
				<v-chip-group>
					<v-chip>{{ $t('moq') }}: {{product.moq}}</v-chip>
				</v-chip-group>
			</div>
			<div class="container" v-if="checkProductPurchased()">
				<div class="add-btn">{{ $t('addedToCatalogue') }}</div>
			</div>
			<div v-else>
				<v-card-actions>
					<v-btn 
						class="sendInquiryBtn"
						v-if="clientId !== product.client_id"
						@click="openProductInquiryForm(product)"
						>
						{{ $t('sendInquiry') }}
					</v-btn>

					<v-btn 
						class="readMoreBtn"
						@click="showDetails = true"
					>
						{{ $t('readMore') }}
					</v-btn>
				</v-card-actions>

				<!-- PULSE ICON -->
				<div class="pulseContainer" v-if="clientId !== product.client_id" @click="purchaseProduct(product)">
					<div class="pulse">
						<svg
						version="1.1"
						id="Capa_1"
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						x="0px"
						y="0px"
						viewBox="0 0 60.364 60.364"
						style="enable-background:new 0 0 60.364 60.364;"
						xml:space="preserve"
						>
						<g>
							<path fill=#fff
							d="M54.454,23.18l-18.609-0.002L35.844,5.91C35.845,2.646,33.198,0,29.934,0c-3.263,0-5.909,2.646-5.909,5.91v17.269
							L5.91,23.178C2.646,23.179,0,25.825,0,29.088c0.002,3.264,2.646,5.909,5.91,5.909h18.115v19.457c0,3.267,2.646,5.91,5.91,5.91
							c3.264,0,5.909-2.646,5.91-5.908V34.997h18.611c3.262,0,5.908-2.645,5.908-5.907C60.367,25.824,57.718,23.178,54.454,23.18z"
							/>
						</g>
						</svg>
					</div>
				</div>
				<!-- end of PULSE ICON -->
			</div>
		</v-card>
		<v-row justify="center">
			<v-dialog 
				v-model="showDetails" 
				width="800"
				transition="dialog-bottom-transition">
				<v-card style="padding: 20px; margin: auto;">
					<v-card-title style="font-weight:800;">{{product.product_name}}</v-card-title>
					<v-img
						:src="`${product.img_path}`"
						width="200px"
						style="float: left; margin: 5px;"
						cover
					></v-img>
					<v-card-text style="text-align:justify; overflow: hidden;">{{product.description}}</v-card-text>
					<v-card-actions>
						<button class="add-btn2" variant="text" @click="showDetails = false">{{ $t('dismiss') }}</button>
					</v-card-actions>
				</v-card>
			</v-dialog>		
		</v-row>
	
	</div>
</template>

<script>
export default {
	data() {
		return {
			id: this.product.id,
			loading: false,
			showDetails: false,
		}
	},
	mounted() {
	},
	methods: {
		openProductInquiryForm(data) {
			this.$emit('open-product-inquiry-form', data)
		},
		purchaseProduct(data) {
			this.$emit('open-product-purchase-form', data)
		},
		checkProductPurchased() {
			if (this.product.client_id) {
				return (this.parentProductIds['OWN'] && this.parentProductIds['OWN'].indexOf(this.product.product_id) > -1)
			} else {
				return (this.parentProductIds['ECOMMERCE'] && this.parentProductIds['ECOMMERCE'].indexOf(this.product.product_id) > -1)
			}
		},
		reserve () {
        this.loading = true
        setTimeout(() => (this.loading = false), 2000)
      },
	},
	props: {
		product: {
			type: Object,
			default: () => {
				return {}
			}
		},
		clientId: {
			type: Number
		},
		parentProductIds: {
			type: Object,
			default: () => {
				return {}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.fitProductImage {
	width: 100% !important;
  	object-fit: cover !important;
}
.productCard {
	height: 520px !important;
	margin: 20px 10px !important;
	max-width: 344px;
}
.pulseContainer  {
	background: none !important;
	position: absolute;
    bottom: 80px;
    right: 30px;
}

.card-title {
	width: 320px;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 2;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	margin-top:10px;
	margin: auto;
	margin-left: 20px !important;
	font-size: 1.5rem;
}
.bold {
	font-weight: 700 !important;

}
.stock-general {
	display: inline;
}
.description {
	max-height: 200px;
	white-space: inherit;
	overflow: hidden;
	text-overflow: ellipsis;
	text-align: justify;
    font-size: 0.7rem;
}

.sendInquiryBtn {
	background-color: var(--bg-light) !important;
    border: none;
    color: var(--bright);
    box-shadow: none;
    font-weight: 600;
}

.readMoreBtn {
	background-color: none !important;
    border: none;
    color: var(--bg-light);
    box-shadow: none;
    font-weight: 600;
}

.pricingDetails {
	text-align: left;
    margin-top: 10px;
}

.suggSellingPrice {
	font-size: 0.7rem;
}

.card-img-top {
	height: 100px;
	width: auto;
	margin: auto;
	max-width: 200px !important;
}
.container  {
	position: absolute;
    top: 0;
    left: 0%;
	padding-top:0;
}
.card-body {
    /* flex: 1 1 auto;
    min-height: 1px; */
	padding: 0.25rem 0rem;
}
/* .card-name {
	color: #454655;
}
.card-text {
	color: #454655;
} */

.add-btn {
	background: var(--primaryDark);
	color: var(--bright);
    // padding: 0.3em;
    letter-spacing: 3px;
	border-radius: 5px;
	text-transform: uppercase;
    width: auto;
}

.add-btn2 {
	background: var(--primaryDark);
	color: var(--bright);
    padding: 0.5em;
    letter-spacing: 3px;
    width: auto;
    border-radius: 10px;
    margin: auto;
}
.inquiry-btn {
	color: var(--bg-light) !important;
	border: 1px solid var(--bg-light);
	background: none;
	text-decoration: none;
	text-transform: uppercase;
	font-weight: 500;
	letter-spacing: 1px;
	font-size: 1em;
	padding: 5px 10px;
	border-radius: 5px;
	transition: 0.3s;
	transition-property: background;
	margin: auto;
	width: 100%;
	margin-bottom: 10px;
	margin-top: 10px;
}

.inquiry-btn:hover {
	background: var(--primaryDark);
	color: var(--bright) !important;
}
.icon {
	font-size: 1.3em;
	padding: 1px;
	float: right;
	cursor: pointer;
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(251, 115, 119, 0.7), 0 0 0 0 rgba(201, 92, 95, 0.7);
  }
  40% {
    transform: scale(1);
    box-shadow: 0 0 0 40px rgba(251, 115, 119, 0),
      0 0 0 0 rgba(201, 92, 95, 0.7);
  }
  80% {
    transform: scale(1);
    box-shadow: 0 0 0 40px rgba(251, 115, 119, 0),
      0 0 0 20px rgba(201, 92, 95, 0);
  }
  100% {
    transform: scale(0.9);
    box-shadow: 0 0 0 0 rgba(251, 115, 119, 0.7),
      0 0 0 20px rgba(201, 92, 95, 0);
  }
}

div[class^='pulse'] {
  background: var(--primaryDark);
  border-radius: 50%;
  color: white;
  cursor: pointer;
  height: auto;
  margin: auto;
  padding: 1.2em;
  text-align: center;
  width: 60px;
}

.pulse:active {
  animation: pulse 0.25s infinite ease-out;
}
.pulse:hover {
  background: #c95c5f;
}

@media only screen and (max-device-width: 1100px) {
	.productCard {
		height: auto !important;
	}
}

@media only screen and (min-device-width: 1100px) {
	.productCard {
		width: 344px !important;
	}
}

@media only screen and (min-device-width: 500px) {
	.card-title {
		margin-top: 10px;
		line-height: 30px;
	}
.productCard:hover {
	background: rgba(128, 128, 128, 0.1) !important;
	box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px;
	margin: 10px !important;
	transform: scale(1.03);
}
}

@media only screen and (max-device-width: 500px) {
	.productCard {
		margin: auto;
	}
	.card-title {
		margin-top: 8px;
		line-height: 25px;
	}
}
@media only screen and (min-device-width: 300px) and (max-device-width: 359px){
	.card-title {
	width: 240px;
	font-size: 1.2rem;
}
.sendInquiryBtn {
	font-size: 0.7rem !important;
}
.readMoreBtn {
	font-size: 0.7rem !important;
}
.pulseContainer {
	bottom: 30px !important;
    right: 10px !important;
}
.pulse {
	padding: 10px !important;
    width: 40px !important;
}
}

@media only screen and (min-device-width: 360px) and (max-device-width: 379px){
	.card-title {
	width: 270px;
}
}
@media only screen and (min-device-width: 381px) {
	.card-title {
	width: 300px;
}
}
// @media only screen and (min-device-width: 400px) {
// 	.card-title {
// 	width: 305px;
// }
// }
</style>
